// Mirrors the backend's autonomy_policy.check_entitlement step 2d: "NULL/empty
// allowed_tools = no restriction (all tier-allowed tools pass)". An empty array
// is NOT a "zero tools" / lockdown state on this field — only permission_tier
// and the Tool Registry restrict what an agent can do. Any UI that renders an
// empty allowed_tools list as "blocked" or "0 selected" is lying about what
// will actually happen at execution time.
export function isUnrestrictedAllowlist(allowedTools) {
  return allowedTools === null || allowedTools === undefined || allowedTools.length === 0;
}
